import { HStack, VStack } from '@chakra-ui/react';
import { CompanyAssessment } from 'models';
import { Typography } from 'Tokens';
import { ExcelFileIcon } from 'Tokens/Icons/FileIcons';
import { useTranslation } from 'utils/translation';
import { useTaxonomyTableData } from './TaxonomyTableGeneratorDeprecated.hooks.ts';
import mixpanel from 'mixpanel-browser';
import { TRACKING_EVENTS } from 'utils/mixpanel';
import { generateDeprecatedTaxonomyTable } from './table-generator-deprecated.ts';

export const TaxonomyTableGeneratorDeprecated = ({
  assessment,
  isGroup,
}: {
  assessment?: CompanyAssessment;
  isGroup?: boolean;
}) => {
  const { data: taxonomyData } = useTaxonomyTableData(assessment?.id, isGroup);
  const { t } = useTranslation('assessment');
  const generate = () => {
    generateDeprecatedTaxonomyTable(taxonomyData);

    mixpanel.track(TRACKING_EVENTS.ASSESSMENTS.TABLE_DOWNLOAD);
  };

  return (
    <HStack w="100%" spacing="10.33px" onClick={generate}>
      <ExcelFileIcon />
      <VStack alignItems="start" spacing="0px">
        <Typography variant="bodyStrong">EU Taxonomy Table - Pre-2026</Typography>
        <Typography variant="detail">{t('assessment:export.euTable.doc')}</Typography>
      </VStack>
    </HStack>
  );
};
